import { Button, Text } from '@chakra-ui/react';
import { ReactComponent as NewTabIcon } from 'assets/icons/new-tab.svg';
import { BRAND_REDIRECT_LINK } from 'constants/links';
import { useTranslation } from 'react-i18next';

interface BrandKitRedirectButtonProps {
  buttonLabel: string;
  hasBrandEditPermission: boolean;
}

export const BrandKitRedirectButton = ({ buttonLabel, hasBrandEditPermission }: BrandKitRedirectButtonProps) => {
  const { t } = useTranslation('auto_brand', { useSuspense: false, keyPrefix: 'modals.autoBrand' });
  return (
    <>
      {hasBrandEditPermission && (
        <Button
          as='a'
          href={BRAND_REDIRECT_LINK}
          target='_blank'
          rel='noopener noreferrer'
          leftIcon={<NewTabIcon />}
          size='md'
          variant='action'
          marginTop={4}
          w='full'
          data-testid='brand-kit-redirect-btn'
        >
          {buttonLabel}
        </Button>
      )}
      {!hasBrandEditPermission && (
        <Text fontSize='sm' data-testid='ask-admin-brand-text' fontWeight='semibold' textAlign='center' marginTop={4}>
          {t('askYourAdmin')}
        </Text>
      )}
    </>
  );
};
